<div class="seo-accordion-container {{ component.slopingUpperEdge == 'true' ? 'withEdge' : '' }}" [ngClass]="component.background">
  <svg viewBox="0 0 200 12" class="tilt" *ngIf="component.slopingUpperEdge == 'true'">
    <path d="M 0,12 200,0 v 12 H 0 Z"></path>
  </svg>
  <div class="content">
    <div class="text">
      <kion-headline-tag [title]="component.title" [titleSize]="component.titleSize"></kion-headline-tag>
    </div>
    <div class="accordion" *ngFor="let component of lazyLoadedComponents$ | async">
      <kion-cms-accordion [component]="component"></kion-cms-accordion>
    </div>
  </div>
</div>
